import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Loader} from 'semantic-ui-react';
import {numbersDictionary, matrixValuesTypes} from '../../../common/dictionaries/classification';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {manualsValues} from '../../../common/constants/lists';
import {parseProviders} from '../../../common/util/options';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import IccGroup from './iccGroup';
import './matrix.scss';

const groups = ['A', 'B', 'C', 'D', 'E'];
const subGroups = ['1', '2', '3', '4', '5'];

class IccMatrix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'provider': '',
      'type': '',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.IccMatrix, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearIccParametersByProvider();
    this.props.loadProviders({'fields': 'code,name'});
    this.props.fetchIccParameters();
  }

  changeProvider(value) {
    this.setState({'provider': value});
    this.props.fetchIccParametersByProvider(value);
  }

  getEmptyFieldsSafetyStockMad() {
    const {iccParameters} = this.props;
    const madValues = iccParameters.mad || {};
    const emptyFields = manualsValues.filter((manualValue) => {
      return !madValues[manualValue] || madValues[manualValue] === 0;
    });

    if (emptyFields) {
      emptyFields.forEach((element, index) => {
        let emptyField = element;
        emptyField = emptyField.replace('manualSafetyStockMad', 'Safety Stock Mad ');
        emptyField = emptyField.replace('One', '1');
        emptyField = emptyField.replace('Two', '2');
        emptyField = emptyField.replace('Three', '3');
        emptyField = emptyField.replace('Four', '4');
        emptyField = emptyField.replace('Five', '5');
        emptyFields[index] = emptyField;
      });
    }
    return emptyFields;
  }

  renderEmptyFieldsSafetyStockMad(emptyFields) {
    return emptyFields.map((emptyField, index) => {
      return (
        <li key={index} className='empty-field'>{emptyField}</li>
      );
    });
  }

  getManualValues(group, subGroup) {
    const {iccParameters, parametersByProvider} = this.props;
    const madValues = iccParameters.mad || {};

    if (!parametersByProvider.manual) {
      return {};
    }

    const manualValues = {...parametersByProvider.manual};
    manualValues.safetyStockMad =
      madValues[`manualSafetyStockMad${group}${numbersDictionary[subGroup]}`];
    return manualValues;
  }

  getCalculatedValues(group, subGroup) {
    const {iccParameters, parametersByProvider} = this.props;
    const madValues = iccParameters.mad || {};
    const {type} = this.state;

    if (!parametersByProvider.calculated) {
      return {};
    }

    const calculatedValues = {...parametersByProvider.calculated};
    calculatedValues.safetyStockMad =
      madValues[`${type}SafetyStockMad${group}${numbersDictionary[subGroup]}`];
    return calculatedValues;
  }

  renderMatrix() {
    const {iccParameters} = this.props;
    const categoriesValues = iccParameters.categories;
    const rows = [];
    groups.forEach((group) => {
      const columns = [];
      const groupMaxValue = categoriesValues[`${group.toLowerCase()}Max`];
      columns.push(
        <td key={`${group}-max-values`} className='left-labels'>
          <div>{groupMaxValue}</div>
        </td>
      );

      subGroups.forEach((subGroup) => {
        columns.push(
          <td key={`${group}${subGroup}`}>
            <IccGroup header={`${group}${subGroup}`} manual={this.getManualValues(group, subGroup)}
              calculated={this.getCalculatedValues(group, subGroup)}
              group={group.toLowerCase()} />
          </td>
        );
      });

      columns.push(
        <td key={`${group}-labels`} className='labels right-labels'>
          <div>Manual</div>
          <div>Calculado</div>
        </td>
      );
      rows.push(<tr key={`${group}`}>{columns}</tr>);
    });
    return rows;
  }

  renderBottomLabels() {
    const {iccParameters} = this.props;
    const categoriesValues = iccParameters.categories;
    const rows = [];
    const columns = [];
    columns.push(
      <td key='E-min-value' />
    );

    subGroups.forEach((subGroup) => {
      const subGroupMaxValue =
        categoriesValues[`${numbersDictionary[subGroup].toLowerCase()}Max`];
      columns.push(
        <td key={`${subGroup}-max-value`} className='left-labels'>{subGroupMaxValue}</td>
      );
    });
    rows.push(<tr key={'button-labes'}>{columns}</tr>);
    return rows;
  }

  renderData() {
    const {loadingIccParameters} = this.props;
    if (loadingIccParameters) {
      return <Loader active inline='centered' />;
    }
    const existEmptyFieldsSafetyStockMad = this.getEmptyFieldsSafetyStockMad();
    if (existEmptyFieldsSafetyStockMad.length > 0) {
      return (
        <div>
          No se puede mostrar la matriz ICC porque los siguientes campos aún no han sido llenados:
          <ul>
            {this.renderEmptyFieldsSafetyStockMad(existEmptyFieldsSafetyStockMad)}
          </ul>
        </div>
      );
    }
    const {provider, type} = this.state;
    if (provider === '' || type === '') {
      return (
        <div>Por favor seleccione un Proveedor y Tipo para visualizar la matriz ICC</div>
      );
    }
    return (
      <table className='matrix'>
        <tbody>
          {this.renderMatrix()}
          {this.renderBottomLabels()}
        </tbody>
      </table>
    );
  }

  render() {
    const {loadingProviders, providers} = this.props;
    return (
      <div className='icc-matrix'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Matriz ICC</h2>
              <div className='title-bar-actions'>
                <Dropdown
                  selection
                  options={parseProviders(providers)}
                  search
                  disabled={loadingProviders}
                  loading={loadingProviders}
                  onChange={(e, {value}) => this.changeProvider(value)}
                  placeholder='Seleccione Proveedor'
                />

                <Dropdown
                  options={matrixValuesTypes}
                  selection
                  onChange={(e, {value}) => this.setState({'type': value})}
                  placeholder='Seleccione Tipo'
                />
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised className='matrix-container'>
          {this.renderData()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loadingIccParameters': state.iccmatrix.loading,
    'iccParameters': state.iccmatrix.parameters,
    'loadingParametersByProvider': state.iccmatrix.loadingParametersByProvider,
    'parametersByProvider': state.iccmatrix.parametersByProvider,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  clearIccParametersByProvider,
  loadProviders,
  fetchIccParameters,
  fetchIccParametersByProvider,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  clearIccParametersByProvider,
  loadProviders,
  fetchIccParameters,
  fetchIccParametersByProvider,
  navigateTo,
})(IccMatrix);
